var _ellipse, _ellipse2, _path, _ellipse3, _ellipse4, _path2, _ellipse5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunicationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 70,
    viewBox: "0 0 93 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.7437,
    cy: 35.7789,
    rx: 3.59244,
    ry: 3.63818,
    fill: "#FFC700"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.4789,
    cy: 23.2476,
    rx: 3.59244,
    ry: 3.63818,
    fill: "#FFC700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11156 53.8358C4 50.5266 4 48.0228 4 37.3661C4 26.7094 4 21.3797 8.11156 18.0705C12.2287 14.7584 18.8454 14.7584 32.0844 14.7584C45.3234 14.7584 51.9429 14.7584 56.0544 18.0705C60.1688 21.3797 60.1688 26.7094 60.1688 37.3661C60.1688 48.0228 60.1688 50.5266 56.0544 53.8358C51.9457 57.1479 45.3234 57.1479 32.0844 57.1479C25.0352 57.1479 21.4123 62.0594 15.2338 65.6257V56.5488C12.1613 56.0881 9.90053 55.2771 8.11156 53.8358Z",
    stroke: "#0D6EFD",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7689,
    cy: 35.7789,
    rx: 3.59244,
    ry: 3.63818,
    fill: "#FFC700"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.1176,
    cy: 35.7791,
    rx: 3.59244,
    ry: 3.63818,
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6828 44.2683L63.0393 49.2304C63.1981 49.4008 63.3895 49.5366 63.6019 49.6293C63.8143 49.7221 64.0432 49.77 64.2745 49.77C64.5058 49.77 64.7346 49.7221 64.947 49.6293C65.1594 49.5366 65.3509 49.4008 65.5097 49.2304L71.3317 43.3317H78.3903C79.7808 43.332 81.1578 43.0548 82.4426 42.5157C83.7273 41.9766 84.8946 41.1863 85.8778 40.19C86.8609 39.1937 87.6407 38.0108 88.1724 36.709C88.7041 35.4072 88.9775 34.012 88.9768 32.6031V14.7258C88.9768 11.8812 87.8587 9.15301 85.8734 7.14153C83.888 5.13004 81.1953 4 78.3876 4H50.1533C47.3456 4 44.6529 5.13004 42.6676 7.14153C40.6822 9.15301 39.5668 11.8812 39.5668 14.7258",
    stroke: "#0D6EFD",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.4496,
    cy: 23.2476,
    rx: 3.59244,
    ry: 3.63818,
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationIcon);
export default __webpack_public_path__ + "static/media/Communication Icon.9556ac1058ceaab4f65ca7f85c60ed69.svg";
export { ForwardRef as ReactComponent };